<template>
  <router-view/>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'App',
  data: () => {
    return {
      required_documents: ['PERSONAL_IDENTIFICATION', 'PROVE_OF_ADDRESS', 'CREDIT_HISTORY']
    }
  },
  mounted() {
    // this.fetchMatiConfig();
    if (this.getJwt) this.fetchKycDocuments();
  },
  methods: {
    ...mapActions("documents", ["fetchKycDocuments"]),
    ...mapActions("mati_config", ["fetchMatiConfig"]),
  },
  computed: {
    ...mapGetters("security", ["getJwt"]),
    ...mapGetters("documents", ["items"]),
    already_uploaded_documents: function () {
      let fields = [];
      const ignore_statuses = ['VALID', 'PENDING'];
      this.items.map(item => {
        const {status, kyc_name} = item;
        if (ignore_statuses.includes(status)) fields.push(kyc_name);
      });
      return fields;
    },
    upload_documents_is_needed: function () {
      return ! this.required_documents.every(item => this.already_uploaded_documents.includes(item));
    },
    all_info_added: function () {
      this.required_documents.forEach(rd => {
        if (!this.already_uploaded_documents.includes(rd.toLowerCase())) return false;
      });
      return true;
    }
  },
  watch: {
    getJwt: function (newToken, oldToken) {
      if (newToken !== oldToken) {
        this.fetchKycDocuments();
      }
    },
    items: {
      deep: true,
      handler: function (v) {
        if (!this.getJwt) return;
        if (v && this.upload_documents_is_needed) {
          if (this.$router.currentRoute.name !== 'KYC_DOCUMENTS')
            this.$router.push(`/${this.getJwt}`);
        } else if (v && this.all_info_added) {
          if (this.$router.currentRoute.name !== 'WAIT_FOR_APPROVAL')
            this.$router.push({name: 'WAIT_FOR_APPROVAL'});
        }
      }
    },
  }
}
</script>

<style lang="scss">
@import '@/assets/style/main.scss';

</style>

<style>
/* Estilos globales para corregir v-application-wrap */
.v-application-wrap {
    position: relative !important;
    min-height: 100vh !important;
    height: auto !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    z-index: 1 !important;
}

/* Asegurar que el contenido pueda expandirse */
.v-application {
    position: relative !important;
    min-height: 100vh !important;
    height: auto !important;
    overflow: visible !important;
}

/* Contenedor principal de la aplicación */
.v-application--wrap {
    position: relative !important;
    min-height: 100vh !important;
    height: auto !important;
    overflow: visible !important;
}

/* Asegurar que los elementos de Vuetify no interfieran */
.v-main {
    position: relative !important;
    overflow: visible !important;
    min-height: 100vh !important;
}

/* Contenedor de contenido principal */
.v-content {
    position: relative !important;
    overflow: visible !important;
    min-height: 100vh !important;
}

/* Asegurar que el body y html permitan scroll */
html, body {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    height: auto !important;
    min-height: 100vh !important;
}

/* Contrarrestar estilos de Incode que puedan interferir */
.incode-widget-container,
.incode-widget,
[id*="incode"],
[class*="incode"] {
    position: relative !important;
    z-index: 50 !important;
    max-height: 600px !important;
    overflow: hidden !important;
}

/* Asegurar que el contenido de la página tenga prioridad */
.page-content {
    position: relative !important;
    z-index: 100 !important;
    overflow: visible !important;
}
</style>